export const PostNotFound = () => (
  <div className="mx-auto my-24 max-w-[400px] px-[20px] text-center">
    <h1 className="text-4xl font-bold text-white">Post not found</h1>
    <div className="mt-[20px] text-base text-gray-400">This is a 404 error</div>
    <div className="mt-[30px] text-base text-white">
      Sorry! If this is a problem on our end, we've been notified and are
      working to fix it.
    </div>
  </div>
);
